import styled from '@emotion/styled';
import { ScrollArea } from '@mantine/core';

export const PanelRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

export const PanelHeader = styled('div')(({ theme }) => ({
  minHeight: 40,
  height: 40,
  paddingLeft: theme.spacing.sm,
  paddingRight: theme.spacing.sm,
  display: 'flex',
  alignItems: 'center',
}));

export const PanelBody = styled('div')(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
}));

export const TabsContainerStyles = {
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
} as const;

export const TabsPanelStyles = {
  panel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
} as const;

export const StyledScrollArea = styled(ScrollArea)`
  flex: 1;
  .mantine-ScrollArea-viewport {
    height: 100%;
  }
  .mantine-ScrollArea-viewport > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
